/**
 * Created by Victor Rojo on 29/8/18.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import {MapDisplayGadgget} from "./Gadget";

@Injectable()
export class GadgetService{

  private basePath = "api/v1/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  get(sectionMapId:string): Promise<any>{
    let url = this.basePath + "section_map/" + sectionMapId + "/gadget";
    return this.http.get(url)
      .toPromise()
      .then( res => res as MapDisplayGadgget[])
      .catch( error => this.errorHandler(error) );
  }

  getBySection(iPlaceId, sectionId): Promise<any>{
    let url = this.basePath + "iplace/" + iPlaceId + "/section/" + sectionId + "/gadget";
    return this.http.get(url)
      .toPromise()
      .then( res => res as object[])
      .catch( error => this.errorHandler(error) );
  }

}
